// World panel overrides (organiser demo / testing): time of day and weather.
// Session-only; null means "follow the real clock / weather".
import { create } from 'zustand'
import type { Weather } from './world/weather'

interface WorldOverride {
  tod: 0 | 1 | 2 | null
  wx: Weather | null
  set(patch: Partial<Pick<WorldOverride, 'tod' | 'wx'>>): void
  reset(): void
}

export const useWorldOverride = create<WorldOverride>((set) => ({
  tod: null,
  wx: null,
  set: (patch) => set(patch),
  reset: () => set({ tod: null, wx: null }),
}))
